<template>
	<div>
		<div v-for="u in users" :key="u.id" class="user-data-row-container flex-space-between--center">
			<UserDataRow :user="u" isShowEmail :userData="userShareData(u)" :me="me" :projectId="projectId"> </UserDataRow>
		</div>
	</div>
</template>

<script>
import UserDataRow from '../DataRow/UserDataRow';
import { mapRoleToTitle, userStatus, INVITED } from '@/components/Settings/user.const';

export default {
	name: 'UserDataList',
	components: {
		UserDataRow,
	},
	props: {
		me: { type: Object },
		users: { type: Array, required: true },
		isShowEmail: { type: Boolean },
		isShowLength: { type: Boolean },
		sharedData: { type: Array },
		projectId: { type: Number },
	},
	methods: {
		roleText(user) {
			return user.status === userStatus[INVITED] ? INVITED : mapRoleToTitle(user.role);
		},
		userShareData(user) {
			return this.sharedData.find((u) => u.id === user.user_id);
		},
	},
};
</script>

<style scoped lang="scss"></style>
